// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/assets/scss/theme/pink.scss
// module id = 1186
// module chunks = 50